import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/demos/team-messaging/team-messaging.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
